import { getApiKey } from "../../utils/apiKey";
import React from "react";
import Header from "../header";
import axios from "axios";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { apiCall_domain } from "../api";
import Spinner from "../Spinner/Spinner";
import ServiceTRype from "./serviceType";
import Drawer from "@mui/material/Drawer";
import clsx from "clsx";
import List from "@mui/material/List";
import { makeStyles } from "@mui/styles";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { createGlobalStyle } from "styled-components";
let DetailsAdd = null;
let secDetailsAdd = null;
const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: "auto",
  },
});
const classes = useStyles;
class Reservation extends React.Component {
  state = {
    usersCar: [],
    loading: true,
    problems: [],
    selectedValue: [],
    myAddresses: [],
    selected_addressId: null,
    userId: null,
    vendorAddress: [],
    index: 0,
    value: "male",
    show: false,
    county: [],
    depotId: null,
    VendorHeader: true,
  };
  componentDidMount() {
    const Headers2 = {
      Authorization: getApiKey(),
      "content-type": "application/json",
    };
    axios
      .get(`${apiCall_domain}/customer/splash`, {
        headers: Headers2,
      })
      .then((res) => {
        this.setState({ county: res.data.cities });
      });
    axios
      .get(`${apiCall_domain}/customer/user/cars`, {
        headers: Headers2,
      })
      .then((res) => {
        this.setState({ usersCar: res.data.data, loading: false });
      });
    axios
      .get(`${apiCall_domain}/customer/mechanics/problems`, {
        headers: Headers2,
      })
      .then((res) => {
        this.setState({ problems: res.data.data });
      });
    axios
      .get(`${apiCall_domain}/customer/user/addresses?1`, {
        headers: Headers2,
      })
      .then((res) => {
        this.setState({
          myAddresses: Object.values(res.data.data),
          loading: false,
        });
      });
    axios
      .get(`${apiCall_domain}/customer/depots`, {
        headers: Headers2,
      })
      .then((res) => {
        this.setState({ vendorAddress: Object.values(res.data.data) });
      });
  }

  render() {
    const GlobalStyles = createGlobalStyle`body{
        background: #F9F9F9;
      }`;
    const handleAddAddress = () => {
      this.props.history.push({
        pathname: "/address/addAddress",
        state: this.state.county,
        show: this.props.location.show,
        backToMulti: true,
      });
    };
    const editDetails = async (e) => {
      const wait = await this.state.show;
      this.setState({ show: true });
      this.props.history.push({
        pathname: "/address/addAddress",
        state: this.state.county,
        details: e,
        validation: true,
        backToMulti: true,
      });
    };

    const deleteItem = (e) => {
      const headers = {
        Authorization: getApiKey(),
        "content-type": "application/json",
      };
      const deleteData = { id: e };
      axios
        .post(`${apiCall_domain}/customer/user/addresses/delete`, deleteData, {
          headers: headers,
        })
        .then((res) => {
          window.location.reload();
        });
    };
    const handleChange = (event) => {
      this.setState({ value: event.target.value });
    };
    const secAddressClickHandler = async (item) => {
      const add = await [];
      const first = await {
        Address: item.address,
        Phone: item.phone,
        Title: item.name,
        lat: item.lat,
        lng: item.lng,
      };
      add.push(first);
      secDetailsAdd = add;
      this.setState({ depotId: item.id });
    };
    const addressClickHandler = async (item) => {
      const add = await [];
      const first = await {
        Address: item.address,
        Phone: item.address_phone,
        Title: item.title,
        lat: item.lat,
        lng: item.lng,
      };
      add.push(first);
      DetailsAdd = add;
      this.setState({ userId: item.id });
    };
    const handleChangee = (event) => {
      this.setState(
        { selected_addressId: parseInt(event.target.value), error: "" },
        () => localStorage.setItem("myAddress", this.state.selected_addressId),
      );
    };
    const toggleDrawer = (anchor, open) => (event) => {
      if (
        event.type === "keydown" &&
        (event.key === "Tab" || event.key === "Shift")
      ) {
        return;
      }
      this.setState({ ...this.state, [anchor]: open });
    };

    const list = (anchor) => (
      <div
        className={clsx(classes.list, {
          [classes.fullList]: anchor === "top" || anchor === "bottom",
        })}
        role="presentation"
        onClick={toggleDrawer(anchor, false)}
        onKeyDown={toggleDrawer(anchor, true)}
      >
        <List>
          <div className="drawerMap">
            <div className="ChoseAddress">
              {this.state.index === "female" ? (
                this.state.myAddresses.length != 0 &&
                this.state.DetailsAdd !== null ? (
                  <RadioGroup
                    aria-label="آدرس های من"
                    name="gender1"
                    onChange={(e) => handleChangee(e)}
                  >
                    <div className="addNewAddresses">
                      <div className="addressComTitlemultiVendor">
                        انتخاب آدرس
                      </div>
                      <div
                        className="addressAddMain"
                        onClick={() => handleAddAddress()}
                      >
                        <button>افزودن آدرس</button>
                      </div>
                    </div>
                    {this.state.myAddresses.map((item) => (
                      <div
                        className="innerBoxMultiVendor"
                        onClick={() => addressClickHandler(item)}
                      >
                        <div className="addressMultiVendor">{item.title}</div>
                        <div className="adressBoxMultiVendor">
                          {item.address}
                        </div>
                        <div className="dividerMultiVendor"></div>
                        <div className="addressBoxInnerBottomMultiVendor">
                          <div className="first">
                            <span className="firstSpan">شماره تماس :</span>
                            <span>{item.address_phone}</span>
                          </div>
                          <div className="seccond">
                            {/* <div
                                    className="secDiv"
                                    onClick={() => pushPaige(item)}
                                  >
                                    <img
                                      src="/public/assets/icons/location.svg"
                                      alt="مکان"
                                    />
                                  </div> */}
                            <div
                              className="secDiv"
                              onClick={() => editDetails(item)}
                            >
                              <img
                                src="/public/assets/icons/medad.svg"
                                alt="مکان"
                              />
                            </div>
                            <div
                              className="secDiv"
                              onClick={() => deleteItem(item.id)}
                            >
                              <img
                                src="/public/assets/icons/zarbdar.svg"
                                alt="مکان"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </RadioGroup>
                ) : (
                  <div className="nullAddress">
                    هیچ آدرسی ثبت نشده است
                    <div
                      className="addressAddMain"
                      onClick={() => handleAddAddress()}
                    >
                      <button>افزودن آدرس</button>
                    </div>
                  </div>
                )
              ) : this.state.vendorAddress != null &&
                this.state.secDetailsAdd !== null ? (
                <RadioGroup
                  aria-label="آدرس های من"
                  name="gender1"
                  onChange={(e) => handleChangee(e)}
                >
                  <div className="addNewAddresses">
                    <div className="addressComTitlemultiVendor">
                      انتخاب آدرس
                    </div>
                  </div>
                  {this.state.vendorAddress.map((item) => (
                    <div
                      className="innerBoxMultiVendor"
                      onClick={() => secAddressClickHandler(item)}
                    >
                      <div className="addressMultiVendor">{item.name}</div>
                      <div className="adressBoxMultiVendor">{item.address}</div>
                      <div className="dividerMultiVendor"></div>
                      <div className="addressBoxInnerBottomMultiVendor">
                        <div className="first">
                          <span className="firstSpan">شماره تماس :</span>
                          <span>{item.phone}</span>
                        </div>
                        <div className="seccondTwin">
                          {/* <div
                                  className="secDiv"
                                  onClick={() => pushPaige(item)}
                                > */}
                          {/* <img
                                    src="public/assets/icons/location.svg"
                                    alt="مکان"
                                  /> */}
                          {/* </div> */}
                        </div>
                      </div>
                    </div>
                  ))}
                </RadioGroup>
              ) : (
                <div className="nullAddress">هیچ آدرسی ثبت نشده است</div>
              )}
            </div>
          </div>
        </List>
      </div>
    );

    return (
      <>
        {this.state.loading ? (
          <Spinner />
        ) : (
          <>
            <Header
              showSearchBar={true}
              title={"رزرو سرویس"}
              VendorHeader={this.state.VendorHeader}
            />
            <GlobalStyles />
            <div className="ReservationCom">
              <h1 className="titleReservationCom">نوع سرویس</h1>
              <Tabs>
                <RadioGroup
                  aria-label="gender"
                  name="gender1"
                  value={this.state.value}
                  onChange={handleChange}
                >
                  <TabList>
                    <Tab>
                      <FormControlLabel
                        value="male"
                        control={<Radio />}
                        label="سرویس ثابت"
                        onClick={() =>
                          this.setState({
                            index: "static",
                          })
                        }
                      />
                    </Tab>
                    <Tab>
                      <FormControlLabel
                        value="female"
                        control={<Radio />}
                        label="سرویس سیار"
                        onClick={() =>
                          this.setState({
                            index: "female",
                          })
                        }
                      />
                    </Tab>
                  </TabList>
                </RadioGroup>
                <TabPanel index={0}>
                  <>
                    <ServiceTRype
                      index={this.state.index}
                      problems={this.state.problems}
                      usersCar={this.state.usersCar}
                      depotId={this.state.depotId}
                      props={this.props}
                    />
                    <h1 className="titleReservationCom">انتخاب آدرس</h1>
                    {["bottom"].map((anchor) => (
                      <>
                        {secDetailsAdd !== null && this.state.show === false ? (
                          secDetailsAdd.map((item, i) => (
                            <div
                              className="innerAddressBox"
                              onClick={toggleDrawer(anchor, true)}
                            >
                              <div className="addressMultiVendor">
                                {item.Title}
                              </div>
                              <div className="addressBoxInnerMiddle-multiVendor">
                                {item.Address}
                              </div>
                              <div className="addressBoxInnerBottom-multiVendor">
                                <div className="first">
                                  <span className="firstSpan">
                                    شماره تماس :
                                  </span>
                                  <span>{item.Phone}</span>
                                </div>
                                <div className="seccondTwin">
                                  {/* <div onClick={() => pushPaige(item)}>
                                          <img
                                            src="public/assets/icons/location.svg"
                                            alt="مکان"
                                          />
                                        </div> */}
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <>
                            <div
                              className="addAddressMultiVendor"
                              onClick={toggleDrawer(anchor, true)}
                            >
                              <div className="noUseAddress">
                                <img
                                  src="/public/assets/icons/multiVendorLocation.svg"
                                  alt="pic"
                                />
                                <span className="TXT">انتخاب آدرس</span>
                              </div>
                            </div>
                            <Drawer
                              anchor={anchor}
                              open={this.state[anchor]}
                              onClose={toggleDrawer(anchor, false)}
                            >
                              {list(anchor)}
                            </Drawer>
                          </>
                        )}
                      </>
                    ))}
                  </>
                </TabPanel>
                <TabPanel index={1}>
                  <>
                    <ServiceTRype
                      index={this.state.index}
                      problems={this.state.problems}
                      usersCar={this.state.usersCar}
                      userId={this.state.userId}
                      props={this.props}
                    />
                    <h1 className="titleReservationCom">انتخاب آدرس</h1>
                    {["bottom"].map((anchor) => (
                      <>
                        {DetailsAdd !== null ? (
                          DetailsAdd.map((item, i) => (
                            <div
                              className="innerAddressBox"
                              onClick={toggleDrawer(anchor, true)}
                            >
                              <div className="addressMultiVendor">
                                {item.Title}
                              </div>
                              <div className="addressBoxInnerMiddle-multiVendor">
                                {item.Address}
                              </div>
                              <div className="addressBoxInnerBottom-multiVendor">
                                <div className="first">
                                  <span className="firstSpan">
                                    شماره تماس :
                                  </span>
                                  <span>{item.Phone}</span>
                                </div>
                                <div className="seccondTwin">
                                  {/* <div onClick={() => pushPaige(item)}>
                                          <img
                                            src="public/assets/icons/location.svg"
                                            alt="مکان"
                                          />
                                        </div> */}
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <>
                            <div
                              className="addAddressMultiVendor"
                              onClick={toggleDrawer(anchor, true)}
                            >
                              <div className="noUseAddress">
                                <img
                                  src="/public/assets/icons/multiVendorLocation.svg"
                                  alt="pic"
                                />
                                <span className="TXT">انتخاب آدرس</span>
                              </div>
                            </div>
                            <Drawer
                              anchor={anchor}
                              open={this.state[anchor]}
                              onClose={toggleDrawer(anchor, false)}
                            >
                              {list(anchor)}
                            </Drawer>
                          </>
                        )}
                      </>
                    ))}
                  </>
                </TabPanel>
              </Tabs>
            </div>
          </>
        )}
      </>
    );
  }
}
export default Reservation;
